import styles from "./stock-urgency.module.css"

export default function StockUrgency({ text }: { text: string }) {
  if (!text.trim()) return null
  return (
    <div className={styles.stockUrgency}>
      <span className={styles.stockUrgencyDot} data-testid="stock-urgency-dot" aria-hidden="true" />
      <span>{text}</span>
    </div>
  )
}
